__turbopack_context__.v({
  "btnWrapper": "link-asset-module__ko_qMq__btnWrapper",
});
